export default "__VITE_ASSET__DjhL0fcM__"